module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.showShop) ? _c('span', [_vm._v("\n        分店："), _c('el-select', {
    staticClass: "w150 mr20",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.shopNum),
      callback: function($$v) {
        _vm.shopNum = $$v
      },
      expression: "shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px",
      "overflow": "hidden"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.queryList()
      }
    }
  }, [_vm._v("查询")])], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "offset": _vm.showShop ? 0 : 22
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addType == 2 ? '修改角色' : '新增角色',
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.type),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "type", $$v)
      },
      expression: "formparams.type"
    }
  }, _vm._l((this.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.addType == 1 && _vm.formparams.type !== 3) ? _c('el-form-item', {
    attrs: {
      "label": "分店",
      "prop": "shopNum"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "shopNum", $$v)
      },
      expression: "formparams.shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位名称",
      "prop": "role"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入职位名称"
    },
    model: {
      value: (_vm.formparams.role),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "role", $$v)
      },
      expression: "formparams.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "功能模块"
    }
  }, _vm._l((_vm.dynamicTags), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin": "0 10px"
      },
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "click": function($event) {
          return _vm.changegTitle(item, index)
        },
        "close": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addProgevt()
      }
    }
  }, [_vm._v("添加分类")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择功能",
      "visible": _vm.dialogVisible2,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams2",
    attrs: {
      "model": _vm.formparams2,
      "rules": _vm.rules2,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入分类名称"
    },
    model: {
      value: (_vm.formparams2.name),
      callback: function($$v) {
        _vm.$set(_vm.formparams2, "name", $$v)
      },
      expression: "formparams2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示顺序",
      "prop": "orderIndex"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入显示顺序"
    },
    model: {
      value: (_vm.formparams2.orderIndex),
      callback: function($$v) {
        _vm.$set(_vm.formparams2, "orderIndex", _vm._n($$v))
      },
      expression: "formparams2.orderIndex"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择功能"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "marginTop": "20px"
    },
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.formparams2.checkedCities),
      callback: function($$v) {
        _vm.$set(_vm.formparams2, "checkedCities", $$v)
      },
      expression: "formparams2.checkedCities"
    }
  }, _vm._l((this.empList), function(item, index) {
    return _c('el-checkbox-button', {
      key: index,
      staticStyle: {
        "margin": "10px"
      },
      attrs: {
        "label": item.limitid,
        "border": ""
      }
    }, [_vm._v(_vm._s(item.limitname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm2('formparams2')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm2('formparams2')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "76vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "职位名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 0) ? _c('div', [_vm._v("教练")]) : _vm._e(), _vm._v(" "), (scope.row.type == 1) ? _c('div', [_vm._v("会籍")]) : _vm._e(), _vm._v(" "), (scope.row.type == 2) ? _c('div', [_vm._v("店长")]) : _vm._e(), _vm._v(" "), (scope.row.type == 3) ? _c('div', [_vm._v("董事长")]) : _vm._e(), _vm._v(" "), (scope.row.type == 4) ? _c('div', [_vm._v("会籍主管")]) : _vm._e(), _vm._v(" "), (scope.row.type == 5) ? _c('div', [_vm._v("教练主管")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopNum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工端功能权限"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "width": "500px"
          }
        }, [_c('div', {
          staticClass: "menuTree"
        }, _vm._l((scope.row.tbModuleList), function(item, index) {
          return _c('div', {
            key: index
          }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.tbELimitList), function(item2, index) {
            return _c('span', {
              key: index,
              staticClass: "item2"
            }, [_vm._v("\n                   " + _vm._s(item2.limitname) + "\n                 ")])
          })], 2)
        }), 0), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("鼠标放上查看详情")])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-579abb10"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/configurable/member.vue
// module id = 605
// module chunks = 70